import React from 'react';

interface CompletePipeStepProps {
  pipeConfig: any;
  onFinish: () => void;
}

const CompletePipeStep: React.FC<CompletePipeStepProps> = ({
  pipeConfig,
  onFinish,
}) => {
  const handleViewPipe = () => {
    // Navigate to pipe details page
    window.location.href = `/dashboard/pipes/${pipeConfig.id}`;
  };

  const getProviderName = () => {
    const provider = pipeConfig.pipe_type.LLM?.provider;
    const names: Record<string, string> = {
      'openai': 'OpenAI',
      'anthropic': 'Anthropic Claude',
      'bedrock': 'AWS Bedrock',
      'azure': 'Azure OpenAI',
      'gemini': 'Google Gemini'
    };
    return names[provider] || provider;
  };

  return (
    <div className="card shadow">
      <div className="card-body text-center py-5">
        <div className="mb-4">
          <i className="fas fa-check-circle fa-5x text-success"></i>
        </div>
        
        <h3 className="mb-3">LLM Pipe Created Successfully!</h3>
        
        <p className="text-muted mb-4">
          Your LLM pipe <strong>{pipeConfig.name}</strong> has been created and is ready to use.
        </p>

        <div className="card bg-light mx-auto mb-4" style={{ maxWidth: '600px' }}>
          <div className="card-body">
            <h6 className="card-title mb-3">
              <i className="fas fa-info-circle mr-2"></i>
              Pipe Details
            </h6>
            <table className="table table-sm mb-0">
              <tbody>
                <tr>
                  <th style={{ width: '35%' }}>Pipe Name:</th>
                  <td className="text-left">{pipeConfig.name}</td>
                </tr>
                {pipeConfig.description && (
                  <tr>
                    <th>Description:</th>
                    <td className="text-left">{pipeConfig.description}</td>
                  </tr>
                )}
                <tr>
                  <th>Provider:</th>
                  <td className="text-left">{getProviderName()}</td>
                </tr>
                <tr>
                  <th>Model:</th>
                  <td className="text-left"><code>{pipeConfig.pipe_type.LLM?.model}</code></td>
                </tr>
                <tr>
                  <th>Status:</th>
                  <td className="text-left">
                    {pipeConfig.enabled ? (
                      <span className="badge badge-success">
                        <i className="fas fa-check-circle mr-1"></i>
                        Enabled
                      </span>
                    ) : (
                      <span className="badge badge-secondary">
                        <i className="fas fa-pause-circle mr-1"></i>
                        Disabled
                      </span>
                    )}
                  </td>
                </tr>
                {pipeConfig.cost_tracking?.enabled && (
                  <tr>
                    <th>Cost Tracking:</th>
                    <td className="text-left">
                      <span className="badge badge-info">
                        <i className="fas fa-dollar-sign mr-1"></i>
                        Enabled
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="alert alert-info mx-auto mb-4" style={{ maxWidth: '600px' }}>
          <i className="fas fa-lightbulb mr-2"></i>
          <strong>Next Steps:</strong>
          <ul className="list-unstyled mb-0 mt-2 text-left">
            <li className="mb-2">
              <i className="fas fa-caret-right mr-2"></i>
              View pipe details and test LLM connections
            </li>
            <li className="mb-2">
              <i className="fas fa-caret-right mr-2"></i>
              Monitor usage and costs in the dashboard
            </li>
            <li className="mb-2">
              <i className="fas fa-caret-right mr-2"></i>
              Configure additional rate limits or budgets
            </li>
            <li className="mb-0">
              <i className="fas fa-caret-right mr-2"></i>
              Integrate with your applications
            </li>
          </ul>
        </div>

        <div className="mt-4">
          <button
            className="btn btn-primary btn-lg mr-3"
            onClick={handleViewPipe}
          >
            <i className="fas fa-cog mr-2"></i>
            Configure Pipe
          </button>
          <button
            className="btn btn-outline-secondary btn-lg"
            onClick={onFinish}
          >
            <i className="fas fa-list mr-2"></i>
            Return to Pipes List
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompletePipeStep;
